<div class="modal-header">
  <h3 class="modal-title">Share your feedback</h3>
  <button
    type="button"
    class="close"
    aria-label="Close"
    [disabled]="submitting()"
    (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (sent()) {
  <div class="modal-body sent" role="status">
    <svg class="sent-icon" viewBox="14 16 28 26" aria-hidden="true">
      <path class="sent-tick" d="M18 29.5l7 7 13-14" />
    </svg>
    <h4 class="sent-title">Thank you for helping us improve!</h4>
    <p class="sent-text">The PMT team has received your feedback.</p>
  </div>

  <div class="modal-footer justify-content-between">
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="sendAnother()">
      Send another
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="cancel()">
      Done
    </button>
  </div>
} @else {
  <div class="modal-body" [formGroup]="form">
    <fieldset class="field">
      <legend class="field-label">What is this about?</legend>
      <div class="tiles">
        @for (option of categoryOptions; track option.value) {
          <label class="tile">
            <input
              type="radio"
              formControlName="category"
              [value]="option.value" />
            <span class="tile-check" aria-hidden="true">
              <kendo-icon name="check" />
            </span>
            <kendo-icon [name]="option.icon" class="tile-icon" />
            <span class="tile-text">{{ option.text }}</span>
            <span class="tile-subtext">{{ option.subtext }}</span>
          </label>
        }
      </div>
    </fieldset>

    @if (selectedOption(); as selected) {
      <div class="reveal">
        <div class="reveal-content">
          <div class="field">
            <label id="feedback-text-label" class="field-label">
              Tell us more
              <span class="required" aria-hidden="true">*</span>
            </label>
            <div id="feedback-text-hint" class="field-hint">
              {{ selected.hint }}
            </div>
            <kendo-textarea
              formControlName="text"
              resizable="vertical"
              [rows]="10"
              [maxlength]="maxTextLength"
              [inputAttributes]="{
                'aria-labelledby': 'feedback-text-label',
                'aria-describedby': 'feedback-text-hint'
              }" />
            <div class="counter">{{ textLength() }} / {{ maxTextLength }}</div>
          </div>

          <div class="field">
            <span class="field-label">
              Add images
              <em class="optional">(optional)</em>
            </span>
            <div class="field-hint">
              Screenshots, diagrams or sketches that help us understand your
              idea or the problem.
            </div>
            <app-file-dropzone
              formControlName="screenshots"
              itemLabel="images"
              [allowedExtensions]="screenshotExtensions"
              [maxFileSize]="maxScreenshotSize"
              [maxFiles]="maxScreenshots" />
          </div>
        </div>
      </div>
    }

    @if (submitFailed() && !errorDismissed()) {
      <div class="alert alert-danger submit-error" role="alert">
        @if (serverMessage()) {
          <strong>It wasn't sent.</strong>
          {{ serverMessage() }}
        } @else if (failureCount() > 1) {
          It still wasn't sent (attempt {{ failureCount() }}). Please try again
          in a moment.
        } @else {
          It wasn't sent. Please try again.
        }
        <button
          kendoButton
          type="button"
          fillMode="flat"
          size="small"
          class="dismiss"
          icon="x"
          aria-label="Dismiss"
          (click)="errorDismissed.set(true)"></button>
      </div>
    }
  </div>

  <div class="modal-footer justify-content-between">
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      [disabled]="submitting()"
      (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="!isValid() || submitting()"
      (click)="submit()">
      @if (submitting()) {
        Sending…
      } @else if (submitFailed()) {
        Try again
      } @else {
        Send
      }
    </button>
  </div>
}
